define('model/user.model',['require','exports','module','fukit'],function(require, exports, module) {
  var UserModel = require('fukit').UserModel;

  UserModel.UserByGroupCollection = UserModel.Collection.extend({
    url: UserModel.urlTemplate('/api/v2/user/user/group/:groupName'),
  });

  UserModel.ReviewerUserCollection = UserModel.UserByGroupCollection.extend({
    urlParamDefaults: {
      groupName: 'COI Reviewer',
    },
  });

  module.exports = UserModel;
});

